import React from "react";

import { Info } from "lucide-react";

import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/shared/ui/tooltip.tsx";

const status = {
  "Проходит опрос": "Лид начал прохождение опроса",
  "Без куратора": "Лид зашел в бота, но еще не прошел опрос",
  "Прошел опрос": "Лид, который успешно прошел опрос",
  Отписал: "Лид/Куратор списались",
  Игнорит: "Лид игнорит",
  "Опрос не пройден": (
    <p className="inline">
      Лид не смог пройти опрос <br /> &nbsp;&nbsp;&nbsp;&nbsp;
      <span className="italic">(возраст/вериф/деп)</span>
    </p>
  ),
  Крутит: "Лид находится на стадии прокрутов",
  "Был деп": "Лид совершил депозит",
  Отклонен: "Лид не подходит",
  "Неактуальный статус": "У лида давно не обновлялся статус",
  Греется: "Лид зашел в паблик, прогревается\n\n\n",
  "Пометка Неактуальный статус": "У лида давно не обновлялся статус",
};

export const StatusInfo = () => {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Info className="h-4 w-4 cursor-pointer stroke-textColor" />
        </TooltipTrigger>
        <TooltipContent className="!bg-bgColor">
          {Object.entries(status).map(([title, description]) => {
            if (title === "Пометка Неактуальный статус") {
              return (
                <React.Fragment key={title}>
                  <br />
                  <p className="text-sm text-textColor">
                    <span>
                      • &nbsp;Пометка{" "}
                      <span className="font-bold">Неактуальный статус</span>
                    </span>{" "}
                    - {description}
                  </p>
                </React.Fragment>
              );
            }

            return (
              <p className="text-sm text-textColor" key={title}>
                <span className="font-bold">• &nbsp;&nbsp;{title}</span> -{" "}
                {description}
              </p>
            );
          })}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
